/**
 * Task types that can be switched into survey mode (`settings.isSurvey`):
 * no correct answer, no points, any answer accepted. Mirrors
 * `strum-server/configs/tasks.config.js`.
 */
export const SURVEY_TASK_TYPES = ['choice', 'multiple', 'pairs', 'multiple_pairs'];

export function isSurveyTask(task: { type?: string; settings?: { isSurvey?: boolean } } | undefined) {
  return Boolean(task?.settings?.isSurvey) && SURVEY_TASK_TYPES.includes(task?.type ?? '');
}
